import React from 'react';
import { connect } from 'react-redux';

import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';

import {
    Col,
    Container,
    Row,
} from '@zillow/zrs-comet';

import {
    TwoFactorAuth,
} from '@zg-rentals/particles-js-auth';

// Selectors
import {
    RoutingSelectors,
    UserSelectors,
} from 'app/shared/selectors';

// actions
import UserActions from 'app/shared/actions/UserActions';

// containers
import Page from 'app/shared/containers/Page';

// styled components
import {
    StyledSection,
} from './StyledComponents';

// todo: move
function getBrandSupportLink(brand = 'zillow') {
    return `mailto:accounthelp@${brand}.com`;
}

class TwoFactorAuthPage extends React.Component {
    constructor(props) {
        super(props);

        this.renderContent = this.renderContent.bind(this);
    }

    onRequestCode = ({ contactType }) => {
        const {
            dispatch,
        } = this.props;

        dispatch(UserActions.requestTwoFactorVerificationCode(contactType));
    };

    onSubmitCode = ({ verificationCode }) => {
        const { dispatch } = this.props;

        return dispatch(UserActions.submitTwoFactorVerificationCode(verificationCode));
    };

    onSubmitCodeSuccess = () => {
        const { dispatch, queryString } = this.props;

        const queryParams = ZRMUtils.queryUtils.parse(queryString);

        dispatch(UserActions.getUserAndSettings({}))
            .then(() => {
                // redirect passed from auth-check @zg-rentals/particles-js-auth
                if (queryParams.redirect) {
                    window.location.href = queryParams.redirect;
                } else {
                    window.router.transitionTo('/rental-manager');
                }
            })
            .catch((err) => {
                console.error('error fetching user information in 2fa', err);
            });
    };

    renderContent() {
        const {
            isTwoFactorAuthEnabled,
            phoneNumber,
        } = this.props;

        return (
            <div>
                {isTwoFactorAuthEnabled && (
                    <Container>
                        <StyledSection paddingY="md">
                            <Row paddingY="xs">
                                <Col xs={0} sm={3} />
                                <Col xs={12} sm={6}>
                                    <TwoFactorAuth.Verification
                                        phoneNumber={phoneNumber}
                                        onRequestCode={this.onRequestCode}
                                        onSubmitCode={this.onSubmitCode}
                                        onSubmitCodeSuccess={this.onSubmitCodeSuccess}
                                        supportLink={getBrandSupportLink()}
                                    />
                                </Col>
                                <Col xs={0} sm={3} />
                            </Row>
                        </StyledSection>
                    </Container>
                )}
            </div>
        );
    }

    render() {
        return (
            <Page noPadding={true} className="TwoFactorAuthPage">
                {this.renderContent()}
            </Page>
        );
    }
}

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    queryString: RoutingSelectors.makeSearch(state),
    isTwoFactorAuthEnabled: UserSelectors.makeIsTwoFactorAuthEnabled(state),
    phoneNumber: UserSelectors.makePhoneNumber(state),
});

export { TwoFactorAuthPage };
export default connect(mapStateToProps)(TwoFactorAuthPage);
